import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
} from "react";

import axios from "axios";
import { useAppContext } from "../../AppContext"; // Adjust the path as needed
import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS
import "ag-grid-enterprise";
import { MyDomain } from "../../App";

export default function AdminNewsGet() {
  const [Data, setData] = useState([]);
  const gridRef = useRef(); // Optional - for accessing Grid's API

  function useWindowSize() {
    const [size, setSize] = useState([window.innerHeight, window.innerWidth]);
    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerHeight, window.innerWidth]);
      };
      window.addEventListener("resize", handleResize);
    }, []);
    return size;
  }
  const [height, width] = useWindowSize();
  const { User, Token } = useAppContext();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const fetchData = async () => {
    console.log("aa");
    if (!User || !Token) {
      setError("User or Token is missing");
      setLoading(false);
      return;
    }
    try {
      const response = await axios.get(`${MyDomain}Towns/GetAllTowns`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
        //params: { Id: User.userId },
      });
      setData(response.data);
      console.log(response.data);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setError(err.response.data.error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const [columnDefs, setColumnDefs] = useState([
    {
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      field: "id",
      filter: "agNumberColumnFilter",
      headerClass: "my-header-class",
      valueFormatter: (params) => `${params.value}`,
    },
    {
      flex: width > 766 ? 1 : null,
      field: "town",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },

    {
      flex: width > 766 ? 1 : null,
      field: "direction",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      flex: width > 766 ? 1 : null,
      field: "citizen",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      field: "codeTown",
      filter: "agNumberColumnFilter",
      headerClass: "my-header-class",
      valueFormatter: (params) => `${params.value}`,
    },
  ]);

  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    // console.log(rowData);
    setGridApi(params.api);
  };

  const getRowHeight = (params) => (params.node.group ? 40 : 40);

  const gridOptions = {
    getRowStyle: (params) => {
      if (params.node.rowPinned === "bottom") {
        return { backgroundColor: "#f9f8f9" };
      }
    },
    rowClass: (params) => {
      return params.node.rowIndex === Data.length ? "bottom-row" : "";
    },
    // other grid options...
  };
  var ragCellClassRules = {
    "rag-green-outer": function (params) {
      return params.value === 2008;
    },
    // "rag-amber-outer": function (params) {
    //   return params.value === 2004;
    // },
    // "rag-red-outer": function (params) {
    //   return params.value === 2000;
    // },
  };
  const defaultColDef = useMemo(() => ({
    sortable: true,
    resizable: true, // Add this line to enable resizing
  }));
  // Example of consuming Grid Event
  const cellClickedListener = useCallback((event) => {
    console.log("cellClicked", event);
  }, []);

  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
  const [ChooseDirection, setChooseDirection] = useState("All Districts");

  const Direction = [
    "All Districts",
    "Northern District",
    "Southern District",
    "Jerusalem District",
    "Southern Triangle",
    "Northern Triangle",
    "Haifa and Carmel region",
  ];

  // Filter based on selected direction
  const filteredItems =
    ChooseDirection === "All Districts"
      ? Data
      : Data.filter((item) => item.direction === ChooseDirection);

  return (
    <div>
      <div style={{ paddingTop: 30 }}>
        <a>Choose District</a>
        <div
          style={{
            display: "grid",
            //gridTemplateColumns: "repeat(5, 1fr)",
            gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
            gap: "5px",
            //padding: "5px",
          }}
        >
          {Direction.map((Cat) => (
            <div
              key={Cat}
              style={{
                backgroundColor: ChooseDirection === Cat ? "#27272a" : "white",
                padding: 5,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "1px solid black",
                cursor: "pointer",
              }}
              onClick={() => {
                setChooseDirection(Cat);
              }}
            >
              <a
                style={{
                  color: ChooseDirection === Cat ? "white" : "black",
                  fontSize: 15,
                }}
              >
                {Cat}
              </a>
            </div>
          ))}
        </div>
        <div style={containerStyle}>
          <div style={gridStyle} className="ag-theme-alpine">
            <span style={{ color: "#1a1523", fontSize: 18 }}>
              Towns
              {/* <span style={{ color: "#e4e2e4" }}> • </span>{" "}
            <span style={{ color: "#6f6e77" }}>{startDate}</span> */}
            </span>
            <AgGridReact
              cellClassRules={ragCellClassRules}
              ref={gridRef} // Ref for accessing Grid's API
              rowData={filteredItems} // Row Data for Rows //{[...SendDataToFirstTable, sumRow]} add another column had a total values
              columnDefs={columnDefs} // Column Defs for Columns
              defaultColDef={defaultColDef} // Default Column Properties
              animateRows={true} // Optional - set to 'true' to have rows animate when sorted
              rowSelection="multiple" // Options - allows click selection of rows
              onCellClicked={cellClickedListener} // Optional - registering for Grid Event
              onGridReady={onGridReady}
              gridOptions={gridOptions}
              suppressScrollOnNewData={true}
              getRowHeight={getRowHeight}
              domLayout="autoHeight"
              pagination={true}
              paginationPageSize={10}
            />
          </div>
        </div>
        <style>
          {`
           .ag-theme-alpine .ag-root-wrapper {
             border: none;
           }
          `}
          {`
            .my-header-class {
              background-color: white;
            }
          `}
        </style>
      </div>
    </div>
  );
}
